import { render, staticRenderFns } from "./price-vat-tip.vue?vue&type=template&id=a867cd84"
import script from "./price-vat-tip.vue?vue&type=script&lang=js"
export * from "./price-vat-tip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports